import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setDocUploadStartTime } from '../actions/documents'
import { setFile } from '../actions/file'
import { subscribeToChannel } from '../actions/pusher'
import { tagFunnel, tagPageview } from '../actions/tagmanager'
import { DispatchThunk } from '../actions/types'
import { toggle } from '../actions/ui'
import Button from '../components/base/Button'
import Icon from '../components/base/Icon'
import { UploadConfig } from '../types'
import { MY_COMPUTER } from '../util/dataTestIds'
import commonStyles from './App.css'

interface StateProps {
  uploadConfig?: UploadConfig
  file: File
}

interface DispatchProps {
  openCheckModal: () => void
  showError: (key: string) => void
  tagFunnel: (eventName: string, eventAction: string) => void
  setFile: (file: File) => void
  upload: () => void
}

interface BaseProps {
  focus: boolean
}

export type DocumentUploadProps = StateProps & DispatchProps

export class DocumentUpload extends Component<DocumentUploadProps, BaseProps> {
  constructor(props: DocumentUploadProps) {
    super(props)
    this.state = {
      focus: false,
    }
  }

  checkFile = (file: File, next: (file: File) => void) => {
    const { uploadConfig } = this.props
    if (!uploadConfig) return
    const fileExtension = `.${file.name.split('.').pop()}`

    if ((uploadConfig.extensions as string[]).indexOf(fileExtension) === -1) {
      this.props.showError('alertFileType')
      return
    }

    if (file.size > uploadConfig.filesize.min && file.size > uploadConfig.filesize.max) {
      this.props.showError('alertFileSize')
      return
    }

    this.props.openCheckModal()
    next(file)
  }

  handleChange = (event: React.FormEvent) => {
    const target = event.target as HTMLInputElement
    const file: File = (target.files as FileList)[0]

    this.props.setFile(file)
    this.props.upload()
  }

  focusDiv = () => {
    this.setState({ focus: true })
  }
  blurDiv = () => {
    this.setState({ focus: false })
  }
  render() {
    const { uploadConfig } = this.props
    const { focus } = this.state
    let extensions
    let mimeTypes
    if (uploadConfig) {
      extensions = uploadConfig.extensions.join(',')
      mimeTypes = uploadConfig.mimeTypes.join(',')
    }
    return (
      <Button
        focus={focus}
        tagname="div"
        halfWidth
        inverted
        fileUpload
        disabled={!uploadConfig}
        data-test-id={MY_COMPUTER}
      >
        <Icon name="laptop" size="16" />
        <span>It&apos;s on my computer</span>
        {uploadConfig && (
          <>
            <label className={commonStyles.visuallyHidden} htmlFor="upload_computer">
              Upload from computer
            </label>
            <input
              onClick={() => this.props.tagFunnel('upload paper', 'on my computer')}
              id="upload_computer"
              type="file"
              accept={`${extensions}, ${mimeTypes}`}
              onChange={this.handleChange}
              onFocus={this.focusDiv.bind(this)}
              onBlur={this.blurDiv.bind(this)}
            />
          </>
        )}
      </Button>
    )
  }
}

const mapStateToProps = (state: any) => ({
  uploadConfig: state.app.upload,
  file: state.file,
})

const mapDispatchToProps = (dispatch: DispatchThunk) => ({
  openCheckModal: () => {
    dispatch(tagPageview('/virtual-pageview/paperchecker/processing-your-paper'))
    dispatch(setDocUploadStartTime())
  },
  showError: (key: string) => dispatch(toggle(key, true)),
  // instead of stale reference to uploadStartTime in react component, createDocument action
  // retrieves second argument from store
  tagFunnel: (eventName: string, eventAction: string) => {
    dispatch(tagFunnel(eventName, eventAction))
  },
  setFile: (file: File) => dispatch(setFile(file)),
  upload: () => dispatch(subscribeToChannel()),
})

export default connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps)(DocumentUpload)
